module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client-simplified/component/account-client-simplified/account-client-simplified.component.scss
// module id = ./src/app/account-client-simplified/component/account-client-simplified/account-client-simplified.component.scss
// module chunks = main